import styled from 'styled-components';

export const WrapperInput = styled.div<{
  isError?: boolean;
}>`
  > input {
    border-radius: 4px;
    border: 1px solid #7a959f;
    height: 40px;
    outline: none;
    padding: 0 16px;
    width: 100%;

    &:focus {
      border: 1px solid #745ef6;
    }

    &::placeholder {
      color: #7a959f;
    }
  }

  > div {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-top: 4px;
    color: #7a959f;

    > div {
      font-size: 12px;
      line-height: 16px;

      &:nth-of-type(1) {
        align-items: center;
        display: flex;
        gap: 8px;
        justify-content: flex-start;
      }
    }
  }

  &:has(> input[status='ERROR']) {
    > input {
      border: 1px solid #e8212b;
    }
    > div {
      color: #e8212b;
    }
  }
`;
